var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.73272 17.7924C9.03264 18.0781 9.50738 18.0666 9.79306 17.7666C10.0787 17.4667 10.0672 16.992 9.76728 16.7063L3.51587 10.7517L18.25 10.7517C18.6642 10.7517 19 10.4159 19 10.0017C19 9.58747 18.6642 9.25168 18.25 9.25168L3.51577 9.25168L9.76728 3.29697C10.0672 3.01129 10.0787 2.53655 9.79306 2.23663C9.50738 1.9367 9.03264 1.92516 8.73272 2.21084L1.31379 9.27755C1.14486 9.43845 1.04491 9.6437 1.01393 9.85707C1.00479 9.90386 1 9.95221 1 10.0017C1 10.0512 1.00481 10.0997 1.01398 10.1466C1.04502 10.3598 1.14496 10.5649 1.31379 10.7257L8.73272 17.7924Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.830bdc68.svg";
export { ForwardRef as ReactComponent };